/**
 * Gestion du formulaire de contrat
 */
$(document).ready(function() {
    var max_fields      = 10; //maximum input boxes allowed
    var wrapper         = $(".input_fields_wrap"); //Fields wrapper
    var add_button      = $(".add_field_button"); //Add button ID
    var x = 1; //initlal text box count
    $(add_button).click(function(e){ //on add input button click
        e.preventDefault();
        if(x < max_fields){ //max input box allowed
            x++; //text box increment
            $(wrapper).append(
                        '<div class="vetuste-add"> ' +
                            '<div class="col-lg-5 form-group">' +
                                '<label for="annee" required="required">Année</label>' +
                                '<input type="number" step="1" class="form-control" name="annee[]" min="0">' +
                            '</div>' +
                            '<div class="col-lg-5 form-group">' +
                                '<label for="tauxVetuste" required="required">Taux vetuste</label> ' +
                                '<input type="number" class="form-control" step="0.01" name="tauxVetuste[]"> ' +
                            '</div>' +
                            '<div class="col-lg-1 form-group">' +
                                '<div id="deleteVetuste" class="glyphicon glyphicon-remove remove_field redCross"  title="Supprimer la vetuste"></div> ' +
                            '</div>' +
                        '</div>'); //add input box
        }
    });

    $(wrapper).on("click",".remove_field", function(e){ //user click on remove text
        e.preventDefault();
        $(this).parent().parent().remove(); x--;
    })


    initSuppressionOperationListener(rootUrl);

    function initSuppressionOperationListener(rootUrl){
        $('#btn-supprimer-contrat').click(function(){
            var verif = confirm("Voulez-vous vraiment supprimer ce contrat ?");
            if(verif){
                var idContrat = $('#idContrat').val();
                $.ajax({
                    type:'GET',
                    url: rootUrl+'contrats/supprimerContrat',
                    data: { idContrat: idContrat },
                    async: true,
                    dataType: 'text',
                    contentType: 'application/x-www-form-urlencoded;charset=UTF-8',
                    beforeSend:function(xhr){
                        xhr.overrideMimeType('text/html;charset=UTF-8');
                    },
                    success:function(data, textStatus){
                        document.location.href=rootUrl+'contrats';
                    },
                    error:function(xhr, textStatus, thrownError){
                        alert('Erreur AJAX : '+thrownError);
                    }
                });
            }
        });
    }
});

